export default "__VITE_ASSET__Sahap7gD__"